<template>
  <div>
    <div style="border: 1px solid #ccc; margin-top: 10px;">
      <!-- 工具栏 -->
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
      />
      <!-- 编辑器 -->
      <Editor
        style="height: 400px; overflow-y: hidden;"
        :defaultConfig="editorConfig"
        v-model="content"
        @onChange="onChange"
        @onCreated="onCreated"
      />
    </div>
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  name: 'MyEditor',
  components: { Editor, Toolbar },
  props: {
    html: String
  },
  data() {
    return {
      editor: null,
      toolbarConfig: {
        // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
        // excludeKeys: [ /* 隐藏哪些菜单 */ ],
      },
      editorConfig: {
        placeholder: '请输入内容...',
        // autoFocus: false,

        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            fieldName: 'file',
            maxFileSize: 10 * 1024 * 1024,
            customUpload: this.customUpload,
            uploadImgHooks: {
              success: function(xhr, editor, result) {
              },
              fail: function (xhr, editor, result) {
                // 图片上传并返回结果，但图片插入错误时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
              },
              error: function (xhr, editor) {
                // 图片上传出错时触发
                // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
              }
            }
          },
          uploadVideo: {
            customUpload: this.customUpload,
          }
        },
      }
    }
  },
  computed: {
    content: {
      get() {
        return this.html
      },
      set(newValue) {}
    }
  },
  methods: {
    onCreated(editor) {
      if (this.editor == null) {
        this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
      }
    },
    onChange(editor) {
      // console.log('onChange', editor.getHtml()) // onChange 时获取编辑器最新内容
    },
    insertTextHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.insertText(' hello ')
    },
    printEditorHtml() {
      const editor = this.editor
      if (editor == null) return
      console.log(editor.getHtml())
    },
    disableHandler() {
      const editor = this.editor
      if (editor == null) return
      editor.disable()
    },
    getHtml() {
      return this.editor.getHtml()
    },
    destroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
    },
    async customUpload(file, insertFn) {
      let formData = new FormData()
      formData.append("file", file)
      this.$store.dispatch('padManage/uploadImg',formData).then((res) => {
        insertFn(res, '', '')
      })
    },
  },
  mounted() {
  },
  // beforeDestroy() {
  //   const editor = this.editor
  //   if (editor == null) return
  //   editor.destroy() // 组件销毁时，及时销毁 editor ，重要！！！
  // },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
